var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOptimization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,70.73535a30.73536,30.73536,0,1,0-21.74316-8.9917A30.65317,30.65317,0,0,0,40,70.73535ZM19.31738,19.31689A29.25,29.25,0,1,1,10.75,40,29.28658,29.28658,0,0,1,19.31738,19.31689Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,66.75a26.75,26.75,0,1,0-18.915-7.835A26.57179,26.57179,0,0,0,40,66.75ZM22.14551,22.14551a25.25,25.25,0,1,1,0,35.709A25.083,25.083,0,0,1,22.14551,22.14551Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2168,50.7832A15.2402,15.2402,0,0,1,50.22607,28.7113L41.32861,37.603a2.74737,2.74737,0,0,0-1.42627-.40674,2.77686,2.77686,0,1,0,2.77735,2.77685,2.74171,2.74171,0,0,0-.32471-1.2752L54.53027,26.53027l-1.06054-1.06054-2.18286,2.18139A16.73962,16.73962,0,0,0,28.15625,51.84375ZM39.90234,41.25a1.27686,1.27686,0,1,1,1.27735-1.27686A1.27782,1.27782,0,0,1,39.90234,41.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptimization);
export default __webpack_public_path__ + "static/media/icon_optimization.1175fcfc29bbe0ac153904f970d11494.svg";
export { ForwardRef as ReactComponent };